import React, { useState } from "react";

function ForcePasswordChangeForm({ username, onPasswordChanged, setSnackbar, theme }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    if (e.target.name === "newPassword") setNewPassword(e.target.value);
    if (e.target.name === "confirmPassword") setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || !confirmPassword) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Completa ambos campos.",
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Las contraseñas no coinciden.",
      });
      return;
    }
    setLoading(true);
    try {
      // Aquí deberías llamar al servicio de cambio de contraseña
      // await changePasswordService({ username, newPassword });
      setSnackbar({
        severity: "success",
        visible: true,
        message: "Contraseña cambiada correctamente.",
      });
      setLoading(false);
      onPasswordChanged();
    } catch (err) {
      setSnackbar({
        severity: "error",
        visible: true,
        message: "Error al cambiar la contraseña.",
      });
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col h-[28rem] justify-around m-4"
    >
      <div className="space-y-6 pb-5">
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Usuario
          </label>
          <input
            type="text"
            value={username}
            disabled
            className="w-full text-2xl px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 outline-none"
          />
        </div>
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Nueva Contraseña
          </label>
          <input
            type="password"
            name="newPassword"
            value={newPassword}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>
        <div>
          <label className="block text-2xl font-medium text-zinc-200 mb-2">
            Confirmar Nueva Contraseña
          </label>
          <input
            type="password"
            name="confirmPassword"
            value={confirmPassword}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>
      </div>
      <div className="space-y-4 mb-3">
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: theme?.colors?.tertiary_dark,
            color: theme?.colors?.text_login_light,
          }}
          className="w-full text-[18px] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Cambiando..." : "Cambiar contraseña"}
        </button>
      </div>
    </form>
  );
}

export default ForcePasswordChangeForm;